import React from "react";
import { toast as reactToastifyToast } from "react-toastify";
import { FiCheckCircle, FiXCircle, FiX } from "react-icons/fi";

const ToastContent = ({ type, message, onClose }) => {
  const styles = {
    success: {
      bg: "bg-[#E7F9ED]",
      border: "border-[#00C26C]",
      icon: <FiCheckCircle className="text-[#00C26C]" size={20} />,
      text: "text-gray-900",
    },
    error: {
      bg: "bg-[#FFF5F5]",
      border: "border-[#FF3B30]",
      icon: <FiXCircle className="text-[#FF3B30]" size={20} />,
      text: "text-gray-900",
    },
  };

  const style = styles[type] || styles.success;

  return (
    <div
      className={`
        ${style.bg}
        ${style.border}
        border-l-4
        rounded-lg
        shadow-lg
        p-4
        min-w-[320px]
        max-w-[420px]
        flex
        items-start
        gap-3
        animate-slide-in
      `}
    >
      {/* Icon */}
      <div className="flex-shrink-0 mt-0.5">{style.icon}</div>

      {/* Message */}
      <div className="flex-1">
        <p className={`${style.text} text-sm font-medium leading-relaxed`}>
          {message}
        </p>
      </div>

      {/* Close Button */}
      <button
        onClick={onClose}
        className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
        aria-label="Close"
      >
        <FiX size={18} />
      </button>
    </div>
  );
};

// Custom toast functions
export const toast = {
  success: (message, options = {}) => {
    return reactToastifyToast(
      ({ closeToast }) => (
        <ToastContent type="success" message={message} onClose={closeToast} />
      ),
      {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        closeButton: false, // We have our own close button
        ...options,
      }
    );
  },

  error: (message, options = {}) => {
    return reactToastifyToast(
      ({ closeToast }) => (
        <ToastContent type="error" message={message} onClose={closeToast} />
      ),
      {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        closeButton: false, // We have our own close button
        ...options,
      }
    );
  },
};

export default ToastContent;

